import account from './account'
import setting from './setting'
// qf36
import app from './app'
import SelectData from './SelectData'
import actPlanListPage from './actPlanListPage'
import actApplyListPage from './actApplyListPage'
import actVerListPage from './actVerListPage'
import undoListPage from './undoListPage'
export default { account, setting, app, SelectData, actPlanListPage, actApplyListPage, actVerListPage, undoListPage}